// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: fixed;
  top: 0;
  right: 0;
  margin: 0.5em;
  z-index: 1200;
  width: 350px;
}`, "",{"version":3,"sources":["webpack://./src/modules/app-common/containers/toast-view/toast-view.component.scss"],"names":[],"mappings":"AAEA;EACI,eAAA;EACA,MAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;AADJ","sourcesContent":["@import 'styles/core/variables.scss';\n\n:host {\n    position: fixed;\n    top: 0;\n    right: 0;\n    margin: 0.5em;\n    z-index: 1200;\n    width: 350px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
